import { useState, useEffect, useCallback } from 'react';
import { Space, Select, Form, Input, FormInstance } from 'antd';
import moment from 'moment';
import { getCurrentAcademicYear, yearArray } from "@/lib/dateTime";
import { getOptionArray, getDataArray, selectFilterOption, modalFromLayout } from "@/lib/antdElementFunction";
import { getLangList } from '@/lib/i18n';
import SemesterConfig from "@/config/semester";
import { SemesterType, ExamType } from "@/containers/organization/semesterManagement/types";

const { getSemestersByYear } = SemesterConfig;

type Props = {
  onChangeSemester: (semesterId: number) => void,
  yearSemesterForm: FormInstance,
  setExamList?: (examList: ExamType[]) => void,
};

function YearSemesterToolBar(props: Props) {
  const { onChangeSemester, yearSemesterForm, setExamList } = props;
  const [semesterArray, setSemesterArray] = useState<SemesterType[]>([]);
  const semesterT: any = getLangList("semester");

  const setSemester = (semesterId: number, semesterName: string = '') => {
    const semesterInfo = semesterArray.find((item) => item.semesterId === semesterId) as SemesterType;
    const { examList } = semesterInfo ?? {};

    yearSemesterForm.setFieldsValue({
      semesterId: semesterId || null,
      semesterName: semesterName || semesterInfo?.semesterName || null,
    });
    onChangeSemester(semesterId);
    setExamList?.(examList);
  };

  const getSemesterByMonth = (semesterArray: SemesterType[]) => {
    const month = moment().month(); // 0-11，0是1月，11是12月
    const firstSemesterInfo = semesterArray?.[0] ?? { semesterId: 0, semesterName: '' };

    switch (month) {
      case 8:
      case 9:
      case 10:
      case 11:
      case 0:
      case 1:
        return semesterArray?.find((item) => item.semesterName === 'Semester 1') ?? firstSemesterInfo;
      case 2:
      case 3:
      case 4:
      case 5:
        return semesterArray?.find((item) => item.semesterName === 'Semester 2') ?? firstSemesterInfo;
      case 6:
      case 7:
        return semesterArray?.find((item) => item.semesterName === 'Summer') ?? firstSemesterInfo;
      default:
        return firstSemesterInfo;
    }
  };

  const getSemestersByYearFunction = useCallback(() => {
    const { year } = yearSemesterForm.getFieldsValue();

    getSemestersByYear({ year }).then((res: any) => {
      const semesterArray = res?.value ?? [];
      const isSemesterArrayNotEmpty = semesterArray.length > 0;

      setSemesterArray(semesterArray);
      if (isSemesterArrayNotEmpty) {
        const semesterInfo = getSemesterByMonth(semesterArray);
        const { semesterId, examList, semesterName } = semesterInfo;

        setSemester(semesterId, semesterName);
        setExamList?.(examList);
      } else {
        setSemester(0, '');
        setExamList?.([]);
      }
    });
  }, []);

  useEffect(() => {
    getSemestersByYearFunction();
  }, [getSemestersByYearFunction])

  return (
    <Form
      {...modalFromLayout}
      form={yearSemesterForm}
      initialValues={{
        year: getCurrentAcademicYear().toString(),
      }}
    >
      <Space>
        <Form.Item name="year" label={semesterT.YEAR}>
          <Select
            showSearch
            optionFilterProp="children"
            filterOption={(input: any, option: any) => selectFilterOption(input, option)}
            style={{ width: '200px' }}
            onChange={getSemestersByYearFunction}
          >
            {getOptionArray(getDataArray(yearArray, '', ''))}
          </Select>
        </Form.Item>

        <Form.Item name="semesterId" label={semesterT.SEMESTER}>
          <Select
            showSearch
            optionFilterProp="children"
            filterOption={(input: any, option: any) => selectFilterOption(input, option)}
            style={{ width: '200px' }}
            onChange={(value) => setSemester(value)}
          >
            {getOptionArray(getDataArray(semesterArray, 'semesterId', 'semesterName'))}
          </Select>
        </Form.Item>

        <Form.Item name="semesterName" style={{ display: 'none' }}>
          <Input />
        </Form.Item>
      </Space>
    </Form>
  );
};

export default YearSemesterToolBar;